import React, { Fragment } from 'react';
import Qs from 'qs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { getRealImageSrc, clearSession } from '../../session';
import Gallery from "react-photo-gallery";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import { Link } from 'react-router-dom';


import {
    Modal, ModalBody, ModalHeader, ModalFooter,
    CardHeader,
    Badge,
    Progress,
    Card,
    CardBody,
    Button,
    Input,
    DropdownToggle,
    UncontrolledDropdown,
    DropdownMenu
} from 'reactstrap';
import Swal from 'sweetalert2'
export default class SingleEventProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = { id: props.id, post: { title: "", content: "", datetime: "" } };
    }


    componentDidMount() {
        document.getElementById("single_post_modal_loader").style.display = "block";
        let session = window.localStorage;
        axios.post(session.ch_action_url + "/action/get_single_post", Qs.stringify({
            token: session.ch_token,
            id: this.state.id
        })).then(res => {
            document.getElementById("single_post_modal_loader").style.display = "none";

            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
                this.setState({ isLoading: false });

            }
            else {
                let post = res.data.data;
                this.setState({ post: post });
            }
        });
    }

    static getDerivedStateFromProps(props, state) {
        let new_state = {};
        let flag = false;

        if (props.id !== state.id) {
            new_state.id = props.id;
            flag = true;
        }
        if (flag) {
            return new_state;
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.id !== prevProps.id) {
            document.getElementById("single_post_modal_loader").style.display = "block";
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/get_single_post", Qs.stringify({
                token: session.ch_token,
                id: this.state.id
            })).then(res => {
                document.getElementById("single_post_modal_loader").style.display = "none";

                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                    this.setState({ isLoading: false });

                }
                else {
                    let post = res.data.data;
                    this.setState({ post: post });
                }
            });
        }
    }

    openLightbox(post_id, index) {

        let post = this.state.post;
        
        let images = [];
        for (let i = 0; i < post.images.length; i++) {
            images.push(getRealImageSrc(post.images[i].src))
        }
        this.setState({ current_lightbox_images: images, currentPostImageIndex: index, viewerIsOpen: true });
    }

    closeLightbox() {
        this.setState({ current_lightbox_images: [], currentPostImageIndex: 0, viewerIsOpen: false });
    };


    renderSelectImages({
        index,
        left,
        top,
        photo }, post_id, image_size) {

        let margin = "2px";
        let imgStyle = {
            transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
            width: "100%",
            height: "100%"
        };
        let selectedImgStyle = {
            transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
            transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
            width: "100%",
            height: "100%"
        };
        let cont = {
            backgroundColor: "#eee",
            cursor: "pointer",
            overflow: "hidden",
            position: "relative"
        };

        //calculate x,y scale
        let sx = (100 - (30 / photo.width) * 100) / 100;
        let sy = (100 - (30 / photo.height) * 100) / 100;
        selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;

        // if (direction === "column") {
        //   cont.position = "absolute";
        //   cont.left = left;
        //   cont.top = top;
        // }
        let maxWidth = 500;
        let maxHeight = 350;
        if (photo.height > photo.width) {
            maxWidth = maxHeight * (photo.width / photo.height);
        }
        else {
            maxHeight = maxWidth * (photo.height / photo.width);
        }
        //maxHeight:maxHeight+"px", maxWidth:maxWidth+"px",
        return (
            <div
                style={image_size > 1 ? { margin, height: photo.height, width: photo.width, ...cont } : { margin, maxHeight: maxHeight + "px", maxWidth: maxWidth + "px", height: photo.height, width: photo.width, ...cont }}
                className={"not-selected"}>
                <img
                    alt={photo.title}
                    style={{ ...imgStyle }}
                    {...{ "src": getRealImageSrc(photo.src) }}
                    onClick={() => this.openLightbox(post_id, index)}
                />
                <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style>
            </div>
        );

    }

    handlePostActions(e, action_name, id, value) {
        if (e != null) {
            e.preventDefault();
        }

        if (action_name === "top_action") {
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/update_post_top_status", Qs.stringify({
                token: session.ch_token,
                id: id,
                value: value
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let post = this.state.post;
                    post.top=value;
                    
                    this.setState({ post: post });
                }
            });

        }
        else if (action_name === "highlight_action") {
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/update_post_highlight_status", Qs.stringify({
                token: session.ch_token,
                id: id,
                value: value
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let items = this.state.items;
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].id === id) {
                            items[i].highlight = value;
                            break;
                        }
                    }
                    this.setState({ items: items });
                }
            });
        }
        else if (action_name === "delete_post") {
            Swal.fire({
                title: "Deletion",
                text: "Are you sure to delete this?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
            }).then((result) => {
                if (result.value) {
                    let session = window.localStorage;
                    axios.post(session.ch_action_url + "/action/delete_post", Qs.stringify({
                        token: session.ch_token,
                        id: id
                    })).then(res => {
                        if (res.data.status === -1) {
                            clearSession();
                        }
                        else if (res.data.status === 0) {
                            Swal.fire(
                                'Operation Failed!',
                                res.data.info,
                                'error');
                        }
                        else {
                            let url = window.location.origin + "/home/events";
                            window.location.href=url;
                        }
                    });
                }
            });

        }
        else if (action_name === "create_new_event") {
            let url = window.location.origin + "/" + window.localStorage.ch_domain_name + "/event_editor/0";
            window.open(url, "_blank");
        }
    }

    render() {
        return (
            <Fragment>
                <div className="pt-3 pb-3" id="show_main_content_div">
                    <div class="p-2">
                        <div className="align-items-center justify-content-center loader_100" id="single_post_modal_loader" style={{ width: "100%", display: "none" }}>
                            <Progress value="100" striped animated className="progress-bar progress-animated-alt" color="warning" >Loading Data, please wait...</Progress>
                        </div>
                        <Card className="mb-3" style={{ maxWidth: "800px", margin: "auto" }}>
                            <CardHeader className="border-0">
                                {this.state.post.top === 1 && <span className="ribbon-angle ribbon-angle--top-left ribbon-warning">
                                    <small>Highlight</small>
                                </span>}
                                <div className="d-flex justify-content-between mb-1">
                                    <div className={this.state.post.top === 1 ? "pl-sm-5" : "p-0"}>
                                        <div className="pl-0">
                                            <a className="font-weight-bold font-size-lg text-black" href="" onClick={(e) => e.preventDefault()}>
                                                {this.state.post.title}
                                            </a>

                                        </div>
                                        <div className="d-flex">
                                            <small className="text-black-50 pt-1 d-block">
                                                by: <b className="text-first">{this.state.post.uname}</b>
                                            </small>
                                            <small className="text-black-50 pt-1 d-block ml-2">
                                                on: <b className="text-first">{this.state.post.datetime}</b>
                                            </small>
                                        </div>
                                    </div>
                                    <div className="card-header--actions card-tr-actions d-flex">
                                        {this.state.post.user_role == 1 &&
                                            <UncontrolledDropdown className="ml-2">
                                                <DropdownToggle color="link" className="btn-link-first p-0 font-size-xl text-first no-caret">
                                                    <FontAwesomeIcon icon={['fas', 'angle-down']} />
                                                </DropdownToggle>
                                                <DropdownMenu right >
                                                    <div role="menuitem">
                                                        <Link className="dropdown-item" to={"/event_editor/" + this.state.post.id} target="_blank">Edit</Link></div>
                                                    {this.state.post.top == 0 && <div role="menuitem"><a className="dropdown-item" href="#/" onClick={e => this.handlePostActions(e, "top_action", this.state.post.id, 1)}>Highlight</a></div>}
                                                    {this.state.post.top == 1 && <div role="menuitem"><a className="dropdown-item" href="#/" onClick={e => this.handlePostActions(e, "top_action", this.state.post.id, 0)}>Un-Highlight</a></div>}
                                                    <div className="divider dropdown-divider" />
                                                    <div role="menuitem"><a className="dropdown-item" href="#/" onClick={e => this.handlePostActions(e, "delete_post", this.state.post.id)}>Delete</a></div>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>}
                                    </div>
                                </div>

                            </CardHeader>
                            <div className="card-body pt-0" >
                                <div id={"content_all_" + this.state.post.id} className="post_all_content" dangerouslySetInnerHTML={{ __html: this.state.post.content }} />
                                <Button id={"hide_content_all_" + this.state.post.id} size="sm" outline onClick={e => this.hidePostAllContent(this.state.post.id)} color="first" style={{ display: "none" }} className="btn-pill mt-1">Collapsed</Button>
                                {this.state.post.images !== undefined && this.state.post.images.length > 0 && <Gallery photos={this.state.post.images} renderImage={({ index, left, top, photo }) => this.renderSelectImages({ index, left, top, photo }, this.state.post.id, this.state.post.images.length)} />}
                            </div>
                        </Card>
                    </div>
                </div>

                {this.state.viewerIsOpen && (
                    <Lightbox
                        mainSrc={this.state.current_lightbox_images[this.state.currentPostImageIndex]}
                        nextSrc={this.state.current_lightbox_images[(this.state.currentPostImageIndex + 1) % this.state.current_lightbox_images.length]}
                        prevSrc={this.state.current_lightbox_images[(this.state.currentPostImageIndex + this.state.current_lightbox_images.length - 1) % this.state.current_lightbox_images.length]}
                        onCloseRequest={() => this.setState({ viewerIsOpen: false })}
                        onMovePrevRequest={() =>
                            this.setState({
                                currentPostImageIndex: (this.state.currentPostImageIndex + this.state.current_lightbox_images.length - 1) % this.state.current_lightbox_images.length,
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                currentPostImageIndex: (this.state.currentPostImageIndex + 1) % this.state.current_lightbox_images.length,
                            })
                        }
                    />
                )}

            </Fragment>
        );
    }
}
